const NAME = "DIALOG";

export default NAME;
